import Swiper from 'swiper';
import {
    Navigation,
    Pagination,
    Keyboard,
    Autoplay,
    EffectFade,
} from 'swiper/modules';

// import AOS from 'aos';

Swiper.use([Navigation, Pagination, Keyboard, Autoplay, EffectFade]);

const navigation = (target) => {
    return {
        nextEl: `.${target}-swiper-controls__button__next`,
        prevEl: `.${target}-swiper-controls__button__prev`,
    };
};

$( document ).ready(function() {
    swipers();
});

const swipers = () => {
    videoSliderSwiper();
    partnerSwiper();
    textSliderSwiper();
    relatedSwiper();
};

const relatedSwiper = () => {
    return new Swiper('.block--posts__related', {
        slidesPerView: 1,
        spaceBetween: 30,
        loop: false,
        navigation: navigation('related'),
        breakpoints: {
            1100: {
                slidesPerView: 3,
            },
            850: {
                slidesPerView: 2,
            },
        },
        on: {
            resize: function () {
                var hideNav = this.slides.length <= this.params.slidesPerView;
                $('.swiper-controls', this.el).toggle(!hideNav);
            },
            init: function () {
                var hideNav = this.slides.length <= this.params.slidesPerView;
                $('.swiper-controls', this.el).toggle(!hideNav);
            },
        },
    });
}

const videoSliderSwiper = () => {
    return new Swiper('.block--video-slider__swiper', {
        loop: false,
        freeMode: true,
        spaceBetween: 15,
        centerInsufficientSlides: true,
        freeModeMomentum: false,
        slidesPerView: 1,
        allowTouchMove: false,
        breakpoints: {
            1400: {
                slidesPerView: 1.3,
            },
            992: {
                slidesPerView: 1.1,
            },
            576: {
                slidesPerView: 1.3,
            },
            0: {
                slidesPerView: 1,
            },
        },
        navigation: navigation('videos'),
        on: {
            resize: function () {
                var hideNav = this.slides.length <= this.params.slidesPerView;
                $('.block--video-slider__swiper__nav', this.el).toggle(!hideNav);
            },
            init: function () {
                var hideNav = this.slides.length <= this.params.slidesPerView;
                $('.block--video-slider__swiper__nav', this.el).toggle(!hideNav);
            },
        },
    });
};

const textSliderSwiper = () => {
    return new Swiper('.block--text-slider__swiper', {
        loop: false,
        freeMode: true,
        spaceBetween: 15,
        centerInsufficientSlides: true,
        freeModeMomentum: false,
        slidesPerView: 1,
        allowTouchMove: false,
        breakpoints: {
            1400: {
                slidesPerView: 2.2,
            },
            1100: {
                slidesPerView: 1.8,
            },
            850: {
                slidesPerView: 1.3,
            },
            576: {
                slidesPerView: 1.5,
            },
            0: {
                slidesPerView: 1,
            },
        },
        navigation: navigation('slides'),
        on: {
            resize: function () {
                var hideNav = this.slides.length <= this.params.slidesPerView;
                $('.block--text-slider__swiper__nav', this.el).toggle(!hideNav);
            },
            init: function () {
                var hideNav = this.slides.length <= this.params.slidesPerView;
                $('.block--text-slider__swiper__nav', this.el).toggle(!hideNav);
            },
        },
    });
};

const partnerSwiper = () => {
    return new Swiper('.partners__swiper', {
        loop: false,
        freeMode: true,
        spaceBetween: 0,
        centerInsufficientSlides: true,
        freeModeMomentum: false,
        navigation: navigation('partners'),
        breakpoints: {
            1400: {
                slidesPerView: 6,
            },
            1100: {
                slidesPerView: 5,
            },
            992: {
                slidesPerView: 4,
            },
            576: {
                slidesPerView: 3,
            },
            0: {
                slidesPerView: 2,
            },
        },
        on: {
            resize: function () {
                var hideNav = this.slides.length <= this.params.slidesPerView;
                $('.partners__swiper__nav', this.el).toggle(!hideNav);
            },
            init: function () {
                var hideNav = this.slides.length <= this.params.slidesPerView;
                $('.partners__swiper__nav', this.el).toggle(!hideNav);
            },
        },
    });
};

// $(window).on('resize', function () {
//     AOS.refresh();
// });
